import { getCurrentInstance, Ref } from 'vue';

export default function useStreamResponseReader(aiGeneratedTextRef: Ref | null = null) {
  const _this = getCurrentInstance();
  const proxy: any = _this?.proxy;

  const convertStreamResponse = async (response: any, scroll = false, aiStateRef: any = {}) => {
    const reader = response?.body?.pipeThrough(new TextDecoderStream()).getReader();
    let model;
    let previousValue = '';

    const hasHTMLArtefacts = (currentValue: string, previousValue: string) => {
      return currentValue === '```' || (currentValue === 'html' && previousValue === '```');
    };

    const appendText = (text: string) => {
      let textToAppend = text;
      if (textToAppend.endsWith('\u003e"')) {
        textToAppend = textToAppend.slice(0, -2);
      }

      if (Object.keys(aiStateRef).length > 0) {
        aiStateRef.generatedText = (aiStateRef.generatedText || '') + textToAppend;
      } else if (aiGeneratedTextRef) {
        aiGeneratedTextRef.value += textToAppend;
      } else {
        proxy.aiGeneratedText += textToAppend;
      }

      if (scroll) {
        proxy.scrollToBottom?.();
      }
    };

    const pushGenericLink = (obj: any) => {
      if (aiStateRef) {
        aiStateRef.genericLinks = aiStateRef.genericLinks || [];
        aiStateRef.genericLinks.push(obj);
      } else {
        proxy.aiGenericLinks.push(obj);
      }
    };

    const parseSrc = (srcString: string) => {
      try {
        const parsedObject = JSON.parse(srcString);

        if (parsedObject.title) {
          parsedObject.title = parsedObject.title.replace(/\\u[\dA-F]{4}/gi, (match: any) =>
            String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
          );
        }
        return parsedObject;
      } catch (error) {
        console.error('Error parsing src:', error);
        return null;
      }
    };

    while (true) {
      const { value, done } = (await reader?.read()) || {};
      if (done) break;
      try {
        const valueObject = JSON.parse(value);
        if (valueObject.t === 'end') break;
        if (valueObject.t === 'out') {
          appendText(valueObject.v);
        } else if (valueObject.t === 'src') {
          const srcObject = parseSrc(valueObject.v);
          if (srcObject) {
            pushGenericLink(srcObject);
          }
        }
      } catch (err) {
        try {
          // split multi-line response items into array and parse each item
          const parsedData = JSON.parse(
            `[${value
              .split(/\n/)
              .filter((line: string) => line.trim() !== '')
              .join(',')}]`
          );
          parsedData.forEach((data: any) => {
            if (data?.v != null) {
              if (data.t === 'model') model = JSON.parse(data.v);
              if (data.t === 'out') {
                if (hasHTMLArtefacts(data.v, previousValue)) {
                  previousValue = data.v;
                  return;
                }

                appendText(data.v);
                previousValue = data.v;
              } else if (data.t === 'src') {
                const srcObject = parseSrc(data.v);
                if (srcObject) {
                  pushGenericLink(srcObject);
                }
              }
            }
          });
        } catch (error) {
          console.error('Invalid JSON:', error);
        }
      }
    }

    // return aiGeneratedText;
    return model;
  };

  return {
    convertStreamResponse,
  };
}
